import styled, { css } from 'styled-components';
import {
    IconPlus,
    Text,
} from '@zillow/constellation';
import { Spinner } from '@zillow/zrs-comet';

export const StyledAppointmentDiv = styled.div`
    padding-bottom: ${props => props.theme.ns().spacing.xs()};
`;

export const StyledBtnContainerDiv = styled.div`
    display: inline-block;
    width: 250px;
    padding-left: ${props => props.theme.ns().spacing.sm()};
    vertical-align: top;
`;

export const StyledContactHoursDiv = styled.div`
    display: inline-block;
    width: calc(100% - 90px);
    ${props => props.theme.ns().media.lg(css`
        width: calc(100% - 125px);
    `)};
`;

export const StyledDayLabelText = styled(Text)`
    width: 90px;
    display: inline-block;
    ${props => props.theme.ns().media.lg(css`
        width: 125px;
    `)};
`;

export const StyledDropzoneContainerDiv = styled.div`
    display: flex;
    flex-flow: column;
    height: 200px;

    .DropzoneContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    p {
        position: absolute;
        margin-top: ${props => props.theme.foundation.spacing.getSpacing(0)};
        top: 10px;
    }
`;

export const StyledIconPlus = styled(IconPlus)`
    position: absolute;
    top: 70px;
`;

export const StyledPropertyLogoDiv = styled.div`
    text-align: center;
    margin-bottom: ${props => props.theme.ns().spacing.xs()};
    ${props => props.theme.ns().media.lg(css`
        text-align: left;
    `)};
`;

export const StyledSpinner = styled(Spinner)`
    position: absolute;
    top: 70px;
`;

export const StyledUploadedLogoDiv = styled.div`
    display: inline-block;
    padding-bottom: ${props => props.theme.ns().spacing.sm()};
    width: 250px;
`;
